import { gql } from '@apollo/client';
import ContentTileFields from 'components/ContentTile/ContentTileFields.graphql';
import CollectionFields from 'actions/user/CollectionFields.graphql';

export default gql`
  query GetCollection($id: Int, $shareKey: String, $country: String) {
    Collection(id: $id, shareKey: $shareKey) {
      ...CollectionFields
      description
      safe_description
      plain_description
      person_id
      items {
        books {
          alacarte
          alacarte_available(country: $country)
          authors {
            id
            first_name
            last_name
            is_author
            avatar_name
          }
          isbn
          image_aspect_ratio
          image_credit
          image_name
          image_permission
          price(country: $country) {
            id
            list_price
            offer_price
            currency
            discount_text
          }
          signature_
          title
        }
        people {
          id
          first_name
          last_name
          avatar_name
          is_author
        }
        contents {
          ...ContentTileFields
        }
      }
      cover_image {
        book {
          isbn
          image_name
          image_permission
        }
        primary_image {
          credit
          crops {
            sizes {
              src
              w
              h
            }
            type
          }
          graphictype
          height
          id
          src
          type
          width
        }
        id
        instagram_url
      }
      custom_cover_image
      custom_hero_image
      tags
      can_edit
    }
  }
  ${CollectionFields}
  ${ContentTileFields}
`;
